import { render, staticRenderFns } from "./Deneme.vue?vue&type=template&id=5b9c0c4f&scoped=true&"
import script from "./Deneme.vue?vue&type=script&lang=js&"
export * from "./Deneme.vue?vue&type=script&lang=js&"
import style0 from "./Deneme.vue?vue&type=style&index=0&id=5b9c0c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c0c4f",
  null
  
)

export default component.exports